import { render } from "./IconArrowBack.vue?vue&type=template&id=76a72c26"
import script from "./IconArrowBack.vue?vue&type=script&lang=ts"
export * from "./IconArrowBack.vue?vue&type=script&lang=ts"
script.render = render

export default script